<script>
export default {
    props: {
        genres: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        allGenres() {
            return this.$store.state.genres.genres
        },
        extendedGenres() {
            // return genres from allGenres that also exist in the genres prop, matching by name. return entire genre object from allGenres
            return this.genres.map(genre => {
                const fullGenre = this.allGenres.find(g => g.name === genre)
                return fullGenre || { name: genre, slug: genre }
            })
        },
    },
}
</script>

<template>
    <div class="genres">
        <span
            v-for="genre in extendedGenres"
            :key="genre.slug"
            class="genre"
        >
            <router-link
                :to="{ name: 'genre', params: { slug: genre.slug } }"
            >
                <BaseButton
                    button-type="tagSecondary"
                    size="small"
                    @click="() => {}"
                >
                    <slot>
                        {{ genre.name }}
                    </slot>
                </BaseButton>
            </router-link>
        </span>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.genres {
    display: flex;
    flex-wrap: wrap;
    gap: $s-s;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
}

@include tablet {
    .genres {
        justify-content: flex-start;
    }
}
</style>
